<template>
  <div>
    <CardManagement
      ref="cardManagementModal"
      :customer="customer"
      :selectedCard="currentCard"
      :customerSavedCards="customerSavedCards"
      :showManageCards="showManageCards"
      :notRequiredMessage="notRequiredMessage"
      @cardDeleted="cardDeleted"
      @cardSelected="cardSelected"
      @closed="cardManagementClosed"
    />
    <div v-if="mode == 1">
      <validation-provider v-slot="v" rules="required" mode="lazy">
        <div
          v-if="title"
          class="form-control-label text-muted text-uppercase  mb-0"
        >
          <div v-if="title">{{ title }}</div>
        </div>
        <div v-if="!title" class="form-control-label">Payment Method</div>

        <div
          v-if="currentCard"
          @click.prevent="showCardManagement()"
          style="cursor:pointer"
        >
          <div class="input-group" style="margin-top:11px;">
            <div class="form-control">
              <b-row>
                <b-col md="auto">
                  <CardSvgLarge height="24px" :cardType="currentCard.cardType">
                  </CardSvgLarge>
                </b-col>
                <b-col style="padding: 1px 0 0 0; margin: 0">
                  {{ currentCard.description }}&#160;&#160;&#160;&#160;{{
                    currentCard.expMonth
                  }}/{{ currentCard.expYear }}
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div v-if="!currentCard">
          <b-input-group class="mt-2">
            <b-form-input
              @click.prevent="showCardManagement()"
              style="cursor: pointer;"
              placeholder="No Stored Cards"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                @click.prevent="showCardManagement()"
                variant="outline-primary shadow-none"
                >Add Card</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </div>
        <input v-model="currentCard" style="display:none" />
        <div v-if="v.errors[0]" class="invalid-feedback" style="display: block">
          Add a card
        </div>
      </validation-provider>
    </div>

    <b-row class="m-0" v-if="mode == 2">
      <b-col class="m-0 p-0" md="auto">
        <CardSvgLarge :cardType="currentCard.cardType"></CardSvgLarge>
      </b-col>
      <b-col class="text-right">
        <div class="stat-box-title" style="font-size: 0.85em">
          Card Number
        </div>
        {{ currentCard.description }}
        <div v-if="showChangeCard">
          <a href="#" @click.prevent="showCardManagement()"
            ><small><strong>Change Card</strong></small></a
          >
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<style>
.form-control:hover {
  border-color: #4693ce;
}

.stat-box-body .cardType {
  height: 35px !important;
}
</style>

<script>
import CardManagement from "./CardManagement";
import CardSvgLarge from "./CardSvgLarge";
export default {
  name: "customer-saved-cards",
  props: {
    title: null,
    customer: null,

    selectCustomerSavedCardId: null,
    mode: {
      type: Number,
      default: 1,
    },
    showChangeCard: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CardManagement,
    CardSvgLarge,
  },
  data: function() {
    return {
      customerSavedCards: [],
      selectedCustomerSavedCardId: null,
      showManageCards: false,
    };
  },
  computed: {
    // a computed getter
    currentCard: function() {
      // `this` points to the vm instance
      return this.customerSavedCards.find((e) => {
        return e.id == this.selectedCustomerSavedCardId;
      });
    },
  },

  async created() {
    if (this.selectCustomerSavedCardId)
      this.selectedCustomerSavedCardId = this.selectCustomerSavedCardId;

    await this.getCustomerCards();
  },
  methods: {
    async getCustomerCards() {
      let r = await this.$client.get(
        "/api/customerSavedCard/customerSavedCards?customerId=" +
          this.customer.id
      );

      this.customerSavedCards = r.data.value;

      // No cards show Card Management

      if (this.customerSavedCards.length == 0) {
        this.showCardManagement();
        return;
      }

      var defaultCard = this.customerSavedCards.find((e) => {
        return e.isDefault;
      });

      // if a customer card was set from then don't select a default or the first one
      if (this.selectCustomerSavedCardId) return;

      if (!this.selectedCustomerSavedCardId && defaultCard != null) {
        this.selectCard(defaultCard, true);
      } else if (this.customerSavedCards.length > 0) {
        this.selectCard(this.customerSavedCards[0], true);
      }
    },
    selectCard(card, emit = true) {
      if (emit) this.$emit("onCustomerCardSelect", card);

      if (card) this.selectedCustomerSavedCardId = card.id;
      else this.selectedCustomerSavedCardId = null;
    },
    cardDeleted(card) {
      if (card.id == this.selectedCustomerSavedCardId) this.selectCard(null);

      this.customerSavedCards = this.customerSavedCards.filter(
        (e) => e.id != card.id
      );
    },
    cardSelected(card) {
      this.showManageCards = false;
      this.selectedCustomerSavedCardId = card.id;

      // reset the default and set the new default
      this.customerSavedCards.forEach((e) => {
        if (e.id == card.id) {
          e.isDefault = true;
        } else {
          e.isDefault = false;
        }
      });

      this.selectCard(card);
    },
    cardManagementClosed() {
      this.showManageCards = false;
    },
    showCardManagement() {
      this.showManageCards = true;

      var self = this;

      this.$emitter.once("cardAdded", async (card) => {
        self.showManageCards = false;
        await self.getCustomerCards();
        const newCard = self.customerSavedCards.find((e) => e.id == card.id);
        self.selectCard(card);
      });
    },
  },
};
</script>
